(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    // Country modal: close on backdrop click, close button, or Escape
  document.addEventListener('click', function(e) {
    // Close on backdrop click
    if (e.target.classList.contains('menu-drawer__country-modal-backdrop')) {
      var details = e.target.closest('details');
      if (details) details.removeAttribute('open');
    }
    // Close on close button click
    if (e.target.closest('.menu-drawer__country-modal-close')) {
      var details = e.target.closest('details');
      if (details) details.removeAttribute('open');
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var openModal = document.querySelector('.menu-drawer__country-modal[open]');
      if (openModal) openModal.removeAttribute('open');
    }
  });

  // Country search filter
  document.addEventListener('input', function(e) {
    if (!e.target.classList.contains('menu-drawer__country-search-input')) return;
    var query = e.target.value.toLowerCase().trim();
    var list = e.target.closest('.menu-drawer__country-modal-content').querySelector('.menu-drawer__country-modal-list');
    var items = list.querySelectorAll('.menu-drawer__country-item');
    items.forEach(function(item) {
      var name = item.getAttribute('data-country-name') || '';
      var iso = item.getAttribute('data-country-iso') || '';
      var match = name.indexOf(query) !== -1 || iso.indexOf(query) !== -1;
      item.setAttribute('data-hidden', match ? 'false' : 'true');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
